export default __webpack_public_path__ + "locales/en/OAuth.json?hash=a824c61f6ec32c3cf4fa05b18ccd193b";